import {
  ContractorPortalFetchPartner,
  FetchPartnerPublicInfo,
  Logout,
  SetPartner,
} from 'src/constants/actionTypes'
import { Action } from 'src/utils/reduxUtils'
import { PartnerState } from './types'

const initialState: PartnerState = {
  partnerPublic: null,
  partner: null,
  partnerFetchStatus: 'pending',
}

export const partnerReducer = (
  state: PartnerState = initialState,
  action: Action<any>,
): PartnerState => {
  switch (action.type) {
    case SetPartner.type.SUCCESS:
      return {
        ...state,
        partner: action.payload,
      }
    case FetchPartnerPublicInfo.type.SUCCESS:
      return {
        ...state,
        partnerPublic: action.payload,
      }
    case ContractorPortalFetchPartner.type.REQUEST:
      return {
        ...state,
        partnerFetchStatus: 'pending',
      }
    case ContractorPortalFetchPartner.type.SUCCESS:
      return {
        ...state,
        partnerFetchStatus: 'success',
      }
    case ContractorPortalFetchPartner.type.FAILED:
      return {
        ...state,
        partnerFetchStatus: 'failed',
      }
    case Logout.type.SUCCESS:
      return initialState
    default:
      return state
  }
}
